import { translate } from "app/filters/i18nFilter";
import type { RelativeRange, RelativeRangeType } from "app/pages/sales-intelligence/types/range";

import advancedFilteringI18nKeys from "../../../utils/i18n";

export function translateOption(optionKey: RelativeRangeType | RelativeRange, isForChip = false): string {
    if (isForChip) {
        return translate(advancedFilteringI18nKeys.relativeDateRange.option(optionKey)).toLowerCase();
    }

    return translate(advancedFilteringI18nKeys.relativeDateRange.option(optionKey));
}
